import React from "react";
import Fade from "react-reveal/Fade";

const Description = () => {
	return (
		<Fade>
			<div className="center_wrapper">
				<h2>Upgrade your skills</h2>
				<div className="highlight_description">
					Lorem ipsum dolor sit, amet consectetur adipisicing elit. Delectus
					porro ipsam aperiam beatae sequi earum repellendus hic accusantium,
					repellat officiis molestiae nostrum libero? Excepturi distinctio quas
					rerum tempora iste provident.
				</div>
			</div>
		</Fade>
	);
};

export default Description;
